

















































import { Component, Vue, Prop } from 'vue-property-decorator';

import { Ingredient, User } from '@/api';

import dayjs from 'dayjs';

@Component({
  components: {},
})
export default class IngredientRevisionHistory extends Vue {
  @Prop({ required: true }) readonly ingredientId: string;

  @Prop({ required: true }) readonly ingredientCoreId: string;

  revisions: Ingredient[] = [];

  formatDate(val: string) {
    return val
      ? dayjs(val).format('DD MMMM YYYY, h:mm:ss a')
      : this.$t('common.labels.unknownDate');
  }

  formatRelativeDate(val: string) {
    return val ? dayjs(val).fromNow() : '';
  }

  formatName(user: User | null) {
    return user ? user.fullName : this.$t('common.labels.unknownUser');
  }

  gotoRevision(revision: Ingredient) {
    if (this.ingredientId !== revision.id) {
      this.$router.push({
        name: 'ingredients-edit',
        params: { itemId: revision.id as string },
      });
    }
  }

  async mounted() {
    this.revisions = (
      await Ingredient.where({ coreId: this.ingredientCoreId })
        .includes(['createdBy', 'modifiedBy', 'publishedBy'])
        .order({ modified: 'desc' })
        .all()
    ).data;
  }
}
